export const onClientEntry = () => {
    if (typeof window !== 'undefined' && window.performance) {
        window.performance.mark('gatsby-client-entry')
    }
}

export const onRouteUpdate = ({ location, prevLocation }) => {
    if (typeof window !== 'undefined' && window.performance) {
        window.performance.mark('route-change')
    }

    if (prevLocation && location.pathname !== prevLocation.pathname) {
        window.scrollTo(0, 0)
    }
}
